import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { OrdersGridContainerShipmentMode } from '../../pages/orders-page/containers/orders-grid-container/orders-grid-container.shipment-mode';
import { FulfillmentPlanService } from '../../services/fulfillment-plan-service';
import OrderBatchesGridHotkeys from '../../components/hotkeys/advanced-hotkeys/order-batches-grid-hotkeys';

import Global from '../../store/global-selectors';

const OrderBatchesGrid = () => {
  const fulfillmentPlanIds = useSelector(Global.selectSelectedOrdersIds);
  const fulfillmentPlans = useSelector((state) => Global.selectEntitiesFulfillmentPlansByIds(state, { fulfillmentPlanIds }));

  const hotkeyedFulfillmentPlanIds = useMemo(
    () => fulfillmentPlans.filter(FulfillmentPlanService.shouldShowShipmentWidget).map(({ fulfillmentPlanId }) => fulfillmentPlanId),
    [fulfillmentPlans],
  );

  return (
    <OrderBatchesGridHotkeys fulfillmentPlanIds={hotkeyedFulfillmentPlanIds}>
      <OrdersGridContainerShipmentMode />
    </OrderBatchesGridHotkeys>
  );
};

export default OrderBatchesGrid;
